import React from 'react';
import './App.scss';
import Footer from './components/footer/Footer';
import Contents from './components/contents/Contents';
function App() {
	return (
		<div className='App'>
			<Contents />
			<Footer />
		</div>
	);
}

export default App;
